import Image from 'app/Components/Shared/Image/image';
import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux';
import TextInputWithButton from '../../../../Shared/TextInputWithButton/TextInputWithButton';
import {
  setSimCardNumber,
  setCurrentPopUp,
  validateSimCardNumber,
  removeSimCardNumberAccepted,
} from '../../TransferOrganizationAccountSlice';
import {PopupEnum} from '../../Constant/Constant';

const SimNumberComponent = (props) => {
  const [simCardNumberValid, setSimCardNumberValid] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (props.data.simCardNumberAccepted != null) {
      if (props.data.simCardNumberAccepted === true) {
        setSimCardNumberValid({accepted: true, resultText: 'ה-SIM תקין ופנוי להמשך יצירת הזמנה חדשה'});
      } else {
        setSimCardNumberValid({
          accepted: false,
          resultText: 'ה SIM אינו תקין. עלייך להכניס מספר SIM אחר. מספר שגיאה 03771',
        });
      }
    } else {
      setSimCardNumberValid(null);
    }
  }, [props.data.simCardNumberAccepted]);

  const simValidation = () => {
    let cleanedValue = props.data.simCardNumber?.replace(/\D/g, '');
    if (cleanedValue.length === 18) {
      props.validateSimCardNumber(cleanedValue);
    } else {
      setError(true);
    }
  };
  const handleInputChange = (e) => {
    if (props.data.simCardNumberAccepted) {
      props.removeSimCardNumberAccepted();
    }
    const currentItem = e.nativeEvent.data;
    const regex = /^\d+$/; // Regular expression to allow only digits

    if (regex.test(currentItem) || !e.nativeEvent.data) {
      props.setSimCardNumber(e.target.value);
    } else return null;
  };

  return (
    <div className='transfer-line-sub-step sim-card-number-component borderline'>
      <div className='M_Sub_Title'>מה מספר ה-SIM?</div>

      <TextInputWithButton
        value={props.data.simCardNumber}
        name={'simNumber'}
        type='text'
        error={error ? 'המספר שהקלדת לא תקין. מזכירים שצריך את 18 הספרות' : ''}
        onChange={(e) => {
          setError(false);
          handleInputChange(e);
        }}
        buttonAction={() => {
          simValidation();
        }}
        result={simCardNumberValid}
      />
      {simCardNumberValid == null && (
        <div className='sim-card-number-helper'>
          <a
            className='sim-card-number-popup-link'
            onClick={() => {
              props.setCurrentPopUp(PopupEnum.SimNumberHelper);
            }}>
            איפה אני רואה את מספר ה-SIM? <Image className='icon_link' src={require('./../../icons/info-black.svg')} alt='' />
          </a>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    data: state.TransferOrganizationAccount,
  };
};

const mapDispatchToProps = {setSimCardNumber, setCurrentPopUp, validateSimCardNumber, removeSimCardNumberAccepted};

export default connect(mapStateToProps, mapDispatchToProps)(SimNumberComponent);
